/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';
import {
    type VehicleMovement,
    VehicleMovementFromJSON,
    VehicleMovementToJSON,
} from '../models/VehicleMovement';
import {
    type VehicleMovementCreate,
    VehicleMovementCreateFromJSON,
    VehicleMovementCreateToJSON,
} from '../models/VehicleMovementCreate';
import {
    type VehicleMovementPeriod,
    VehicleMovementPeriodFromJSON,
    VehicleMovementPeriodToJSON,
} from '../models/VehicleMovementPeriod';
import {
    type VehicleMovementPeriodSortKey,
    VehicleMovementPeriodSortKeyFromJSON,
    VehicleMovementPeriodSortKeyToJSON,
} from '../models/VehicleMovementPeriodSortKey';

export interface VehicleMovementsCreateVehicleMovementRequest {
    vehicleMovementCreate: VehicleMovementCreate;
}

export interface VehicleMovementsListVehicleMovementPeriodsRequest {
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    search?: string | null;
    vehicleIds?: Array<string> | null;
    userIds?: Array<string> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: VehicleMovementPeriodSortKey;
}

export interface VehicleMovementsListVehicleMovementPeriodsMetadataRequest {
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    search?: string | null;
    vehicleIds?: Array<string> | null;
    userIds?: Array<string> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: VehicleMovementPeriodSortKey;
}

/**
 * VehicleMovementsApi - interface
 * 
 * @export
 * @interface VehicleMovementsApiInterface
 */
export interface VehicleMovementsApiInterface {
    /**
     * Creates request options for vehicleMovementsCreateVehicleMovement without sending the request
     * @param {VehicleMovementCreate} vehicleMovementCreate 
     * @throws {RequiredError}
     * @memberof VehicleMovementsApiInterface
     */
    vehicleMovementsCreateVehicleMovementRequestOpts(requestParameters: VehicleMovementsCreateVehicleMovementRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new vehicle movement
     * @summary Create a vehicle movement
     * @param {VehicleMovementCreate} vehicleMovementCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMovementsApiInterface
     */
    vehicleMovementsCreateVehicleMovementRaw(requestParameters: VehicleMovementsCreateVehicleMovementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleMovement>>;

    /**
     * Create a new vehicle movement
     * Create a vehicle movement
     */
    vehicleMovementsCreateVehicleMovement(requestParameters: VehicleMovementsCreateVehicleMovementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleMovement>;

    /**
     * Creates request options for vehicleMovementsListVehicleMovementPeriods without sending the request
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {Array<string>} [vehicleIds] 
     * @param {Array<string>} [userIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleMovementPeriodSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof VehicleMovementsApiInterface
     */
    vehicleMovementsListVehicleMovementPeriodsRequestOpts(requestParameters: VehicleMovementsListVehicleMovementPeriodsRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the vehicle movement periods.
     * @summary List vehicle movement periods
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {Array<string>} [vehicleIds] 
     * @param {Array<string>} [userIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleMovementPeriodSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMovementsApiInterface
     */
    vehicleMovementsListVehicleMovementPeriodsRaw(requestParameters: VehicleMovementsListVehicleMovementPeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleMovementPeriod>>>;

    /**
     * Lists all the vehicle movement periods.
     * List vehicle movement periods
     */
    vehicleMovementsListVehicleMovementPeriods(requestParameters: VehicleMovementsListVehicleMovementPeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleMovementPeriod>>;

    /**
     * Creates request options for vehicleMovementsListVehicleMovementPeriodsMetadata without sending the request
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {Array<string>} [vehicleIds] 
     * @param {Array<string>} [userIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleMovementPeriodSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof VehicleMovementsApiInterface
     */
    vehicleMovementsListVehicleMovementPeriodsMetadataRequestOpts(requestParameters: VehicleMovementsListVehicleMovementPeriodsMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total number of pages available.
     * @summary List vehicle movement periods metadata
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {Array<string>} [vehicleIds] 
     * @param {Array<string>} [userIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleMovementPeriodSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleMovementsApiInterface
     */
    vehicleMovementsListVehicleMovementPeriodsMetadataRaw(requestParameters: VehicleMovementsListVehicleMovementPeriodsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total number of pages available.
     * List vehicle movement periods metadata
     */
    vehicleMovementsListVehicleMovementPeriodsMetadata(requestParameters: VehicleMovementsListVehicleMovementPeriodsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

}

/**
 * 
 */
export class VehicleMovementsApi extends runtime.BaseAPI implements VehicleMovementsApiInterface {

    /**
     * Creates request options for vehicleMovementsCreateVehicleMovement without sending the request
     */
    async vehicleMovementsCreateVehicleMovementRequestOpts(requestParameters: VehicleMovementsCreateVehicleMovementRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleMovementCreate'] == null) {
            throw new runtime.RequiredError(
                'vehicleMovementCreate',
                'Required parameter "vehicleMovementCreate" was null or undefined when calling vehicleMovementsCreateVehicleMovement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_movements/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleMovementCreateToJSON(requestParameters['vehicleMovementCreate']),
        };
    }

    /**
     * Create a new vehicle movement
     * Create a vehicle movement
     */
    async vehicleMovementsCreateVehicleMovementRaw(requestParameters: VehicleMovementsCreateVehicleMovementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleMovement>> {
        const requestOptions = await this.vehicleMovementsCreateVehicleMovementRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleMovementFromJSON(jsonValue));
    }

    /**
     * Create a new vehicle movement
     * Create a vehicle movement
     */
    async vehicleMovementsCreateVehicleMovement(requestParameters: VehicleMovementsCreateVehicleMovementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleMovement> {
        const response = await this.vehicleMovementsCreateVehicleMovementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleMovementsListVehicleMovementPeriods without sending the request
     */
    async vehicleMovementsListVehicleMovementPeriodsRequestOpts(requestParameters: VehicleMovementsListVehicleMovementPeriodsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehicleMovementsListVehicleMovementPeriods().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['vehicleIds'] != null) {
            queryParameters['vehicle_ids'] = requestParameters['vehicleIds'];
        }

        if (requestParameters['userIds'] != null) {
            queryParameters['user_ids'] = requestParameters['userIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_movements/periods`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the vehicle movement periods.
     * List vehicle movement periods
     */
    async vehicleMovementsListVehicleMovementPeriodsRaw(requestParameters: VehicleMovementsListVehicleMovementPeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleMovementPeriod>>> {
        const requestOptions = await this.vehicleMovementsListVehicleMovementPeriodsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VehicleMovementPeriodFromJSON));
    }

    /**
     * Lists all the vehicle movement periods.
     * List vehicle movement periods
     */
    async vehicleMovementsListVehicleMovementPeriods(requestParameters: VehicleMovementsListVehicleMovementPeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleMovementPeriod>> {
        const response = await this.vehicleMovementsListVehicleMovementPeriodsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleMovementsListVehicleMovementPeriodsMetadata without sending the request
     */
    async vehicleMovementsListVehicleMovementPeriodsMetadataRequestOpts(requestParameters: VehicleMovementsListVehicleMovementPeriodsMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehicleMovementsListVehicleMovementPeriodsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['vehicleIds'] != null) {
            queryParameters['vehicle_ids'] = requestParameters['vehicleIds'];
        }

        if (requestParameters['userIds'] != null) {
            queryParameters['user_ids'] = requestParameters['userIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_movements/periods/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total number of pages available.
     * List vehicle movement periods metadata
     */
    async vehicleMovementsListVehicleMovementPeriodsMetadataRaw(requestParameters: VehicleMovementsListVehicleMovementPeriodsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.vehicleMovementsListVehicleMovementPeriodsMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total number of pages available.
     * List vehicle movement periods metadata
     */
    async vehicleMovementsListVehicleMovementPeriodsMetadata(requestParameters: VehicleMovementsListVehicleMovementPeriodsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.vehicleMovementsListVehicleMovementPeriodsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
